import { EsquireClient } from "@/types/clients/esquire";
import UpdateGuestPayload
  from "@/types/clients/esquire/payloads/update-guest-payload";
import {
  GuestContactUpdateResult
} from "@/types/clients/esquire/responses/guest-contact-update-result";

export default class PutGuestUpdate {
  constructor(private client: EsquireClient) {}

  public async send(payload: UpdateGuestPayload): Promise<GuestContactUpdateResult> {
    const url = await this.client.fetchUrlFromSession("guest-info-update");

    const response = await this.client.fetch(() => new URL(url), {
      method: "PUT",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload.toJson())
    });

    await this.client.logOutIfForbidden(response.status);

    const data = await response.json() as GuestContactUpdateResult;

    if (!response.ok) {
      throw new Error(data?.message || "Failed to update guest info.");
    }

    return data;
  }
}

